import { CommonModule, isPlatformBrowser } from '@angular/common'
import {
  Component,
  HostListener,
  Inject,
  inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
  type ElementRef,
  type TemplateRef,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgbActiveOffcanvas, NgbOffcanvas, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap'
import { LogoBoxComponent } from '../logo-box.component'
import { ThemeSwitcherComponent } from '../theme-switcher.component'
import { BuyNowButtonComponent } from '../buy-now-button.component'
import { AppMenuComponent } from '../app-menu/app-menu.component'

@Component({
    selector: 'component-topbar',
    imports: [
        CommonModule,
        RouterModule,
        AppMenuComponent,
        LogoBoxComponent,
        ThemeSwitcherComponent,
        BuyNowButtonComponent,
        NgbOffcanvasModule
    ],
    providers: [NgbActiveOffcanvas],
    templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnDestroy {
  @Input() headerClassName: string = ''
  @Input() theme: string = 'light'

  offcanvasService = inject(NgbOffcanvas)
  @ViewChild('topbarHeader') topbarHeader!: ElementRef
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  openMenu(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end' })
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (this.isBrowser && this.topbarHeader?.nativeElement) {
      this.checkScroll();
    }
  }


   ngOnDestroy(): void {
    if (this.isBrowser) {
      const bodyTag = document.body;
      if (bodyTag) {
        bodyTag.style.removeProperty('padding-top');
      }
    }
  }


  checkScroll() {
    const scrollTop =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    const navbarClassList = this.topbarHeader.nativeElement.classList
    const isAbsolute = navbarClassList.contains('position-absolute')
    const offsetHeight = this.topbarHeader.nativeElement.offsetHeight
    const bodyStyle = document.body.style
    if (scrollTop > 500) {
      if (!isAbsolute) bodyStyle.paddingTop = offsetHeight + 'px'
      this.topbarHeader.nativeElement?.classList.add('navbar-stuck')
    } else {
      if (!isAbsolute) bodyStyle.paddingTop = 'unset'
      this.topbarHeader.nativeElement?.classList.remove('navbar-stuck')
    }
  }
}
